import axiosIns from '@/plugins/axios'

export default {
  listInvitations() {
    return axiosIns.get('/admin/cast_app/invitations')
  },
  listCastUsers() {
    return axiosIns.get('/admin/cast_app/invitations/cast_users')
  },
  create(userId) {
    return axiosIns.post('/admin/cast_app/invitations', { user_id: userId })
  },
  destroy(id) {
    return axiosIns.delete(`/admin/cast_app/invitations/${id}`)
  },
}
